// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.ai-coin-dialog {
  width: 100%;
  max-width: min(640px, 100%);
  box-sizing: border-box;
  padding: 1.35rem 1.4rem 1.5rem;
  max-height: min(90vh, 860px);
  max-height: min(90dvh, 860px);
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 1.1rem;
}
.dialog-header .eyebrow {
  margin: 0;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #5ea1d8;
}
.dialog-header h2 {
  margin: 0.25rem 0 0.35rem;
  font-size: 1.35rem;
  color: #0f172a;
}
.dialog-header .subtitle {
  margin: 0;
  color: #64748b;
  font-size: 0.9rem;
  line-height: 1.45;
  max-width: 480px;
}

.close-btn {
  border: none;
  background: #f1f5f9;
  border-radius: 999px;
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #475569;
  flex-shrink: 0;
}

.balance-banner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  border-radius: 10px;
  background: rgba(94, 161, 216, 0.1);
  border: 1px solid rgba(94, 161, 216, 0.22);
}
.balance-banner .label {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
  font-weight: 600;
}
.balance-banner .value {
  font-weight: 700;
  color: #0f172a;
}
.balance-banner .detail {
  font-weight: 500;
  color: #64748b;
  font-size: 0.85rem;
}

.pack-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.75rem;
}
@media (min-width: 640px) {
  .pack-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

.pack-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25rem;
  text-align: left;
  padding: 1rem;
  border-radius: 12px;
  border: 2px solid #e2e8f0;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.pack-card.featured {
  border-color: rgba(94, 161, 216, 0.45);
}
.pack-card.selected {
  border-color: #5ea1d8;
  box-shadow: 0 0 0 1px rgba(94, 161, 216, 0.25);
}
.pack-card .badge {
  position: absolute;
  top: -0.55rem;
  right: 0.65rem;
  background: #5ea1d8;
  color: #fff;
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  padding: 0.15rem 0.45rem;
  border-radius: 999px;
}
.pack-card .pack-name {
  font-weight: 700;
  color: #0f172a;
  margin-top: 0.25rem;
}
.pack-card .pack-coins {
  color: #64748b;
  font-size: 0.9rem;
}
.pack-card .pack-price {
  margin-top: 0.35rem;
  font-size: 1.25rem;
  font-weight: 700;
  color: #5ea1d8;
}
.pack-card .pack-note {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #94a3b8;
  font-weight: 600;
}

.dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-top: 1.25rem;
}

.btn-cancel,
.btn-purchase {
  border-radius: 8px;
  padding: 0.6rem 1.1rem;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid transparent;
}

.btn-cancel {
  background: #fff;
  border-color: #cbd5e1;
  color: #0f172a;
}

.btn-purchase {
  background: #5ea1d8;
  color: #fff;
}

/* Mobile */
@media (max-width: 640px) {
  .ai-coin-dialog {
    padding: 1rem 0.9rem calc(1rem + env(safe-area-inset-bottom, 0px));
    max-height: calc(100vh - 16px);
    max-height: calc(100dvh - 16px);
    border-radius: 16px;
  }
  .dialog-header {
    gap: 0.65rem;
    margin-bottom: 0.9rem;
  }
  .dialog-header h2 {
    font-size: 1.15rem;
  }
  .dialog-header .subtitle {
    font-size: 0.82rem;
    max-width: none;
  }
  .close-btn {
    width: 32px;
    height: 32px;
  }
  .balance-banner {
    flex-direction: column;
    align-items: flex-start;
    padding: 0.7rem 0.85rem;
  }
  .pack-grid {
    grid-template-columns: 1fr;
    gap: 0.65rem;
  }
  .pack-card {
    padding: 0.9rem;
  }
  .dialog-actions {
    flex-direction: column-reverse;
    align-items: stretch;
    gap: 0.55rem;
    margin-top: 1rem;
  }
  .btn-cancel,
  .btn-purchase {
    width: 100%;
    min-height: 44px;
    justify-content: center;
  }
}
/* Dark mode — AI coin top-up modal */
:host-context(body.theme-dark) .ai-coin-dialog {
  background: #111827 !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .dialog-header .eyebrow {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .dialog-header h2 {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .dialog-header .subtitle {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .close-btn {
  background: #1f2937 !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .close-btn mat-icon,
:host-context(body.theme-dark) .close-btn .mat-icon {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .balance-banner {
  background: rgba(94, 161, 216, 0.14) !important;
  border-color: rgba(94, 161, 216, 0.28) !important;
}
:host-context(body.theme-dark) .balance-banner .label,
:host-context(body.theme-dark) .balance-banner .detail {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .balance-banner .value {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .pack-card {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .pack-card.featured {
  border-color: rgba(94, 161, 216, 0.55) !important;
}
:host-context(body.theme-dark) .pack-card.selected {
  border-color: #5ea1d8 !important;
  box-shadow: 0 0 0 1px rgba(94, 161, 216, 0.35) !important;
}
:host-context(body.theme-dark) .pack-card .pack-name {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .pack-card .pack-coins,
:host-context(body.theme-dark) .pack-card .pack-note {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .pack-card .pack-price {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .btn-cancel {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.45) !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .btn-purchase {
  color: #ffffff !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/ai-coin-purchase-dialog/ai-coin-purchase-dialog.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,WAAA;EACA,2BAAA;EACA,sBAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,iCAAA;AAEF;;AACA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,qBAAA;AAEF;AAAE;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AAEJ;AACE;EACE,yBAAA;EACA,kBAAA;EACA,cAAA;AACJ;AAEE;EACE,SAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AAAJ;;AAIA;EACE,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;AADF;;AAIA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mCAAA;EACA,0CAAA;AADF;AAGE;EACE,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;AADJ;AAIE;EACE,gBAAA;EACA,cAAA;AAFJ;AAKE;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;AAHJ;;AAOA;EACE,aAAA;EACA,0BAAA;EACA,YAAA;AAJF;AAME;EALF;IAMI,qCAAA;EAHF;AACF;;AAMA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,0DAAA;AAHF;AAKE;EACE,sCAAA;AAHJ;AAME;EACE,qBAAA;EACA,8CAAA;AAJJ;AAOE;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,wBAAA;EACA,oBAAA;AALJ;AAQE;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;AANJ;AASE;EACE,cAAA;EACA,iBAAA;AAPJ;AAUE;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AARJ;AAWE;EACE,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,gBAAA;AATJ;;AAaA;EACE,aAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;AAVF;;AAaA;;EAEE,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;AAVF;;AAaA;EACE,gBAAA;EACA,qBAAA;EACA,cAAA;AAVF;;AAaA;EACE,mBAAA;EACA,WAAA;AAVF;;AAaA,WAAA;AACA;EACE;IACE,kEAAA;IACA,8BAAA;IACA,+BAAA;IACA,mBAAA;EAVF;EAaA;IACE,YAAA;IACA,qBAAA;EAXF;EAaE;IACE,kBAAA;EAXJ;EAcE;IACE,kBAAA;IACA,eAAA;EAZJ;EAgBA;IACE,WAAA;IACA,YAAA;EAdF;EAiBA;IACE,sBAAA;IACA,uBAAA;IACA,uBAAA;EAfF;EAkBA;IACE,0BAAA;IACA,YAAA;EAhBF;EAmBA;IACE,eAAA;EAjBF;EAoBA;IACE,8BAAA;IACA,oBAAA;IACA,YAAA;IACA,gBAAA;EAlBF;EAqBA;;IAEE,WAAA;IACA,gBAAA;IACA,uBAAA;EAnBF;AACF;AAsBA,qCAAA;AAEE;EACE,8BAAA;EACA,yBAAA;AArBJ;AAyBI;EACE,yBAAA;AAvBN;AA0BI;EACE,yBAAA;AAxBN;AA2BI;EACE,yBAAA;AAzBN;AA6BE;EACE,8BAAA;EACA,yBAAA;AA3BJ;AA6BI;;EAEE,yBAAA;AA3BN;AA+BE;EACE,+CAAA;EACA,iDAAA;AA7BJ;AA+BI;;EAEE,yBAAA;AA7BN;AAgCI;EACE,yBAAA;AA9BN;AAkCE;EACE,8BAAA;EACA,kDAAA;AAhCJ;AAkCI;EACE,iDAAA;AAhCN;AAmCI;EACE,gCAAA;EACA,yDAAA;AAjCN;AAoCI;EACE,yBAAA;AAlCN;AAqCI;;EAEE,yBAAA;AAnCN;AAsCI;EACE,yBAAA;AApCN;AAwCE;EACE,8BAAA;EACA,kDAAA;EACA,yBAAA;AAtCJ;AAyCE;EACE,yBAAA;AAvCJ","sourcesContent":[".ai-coin-dialog {\n  width: 100%;\n  max-width: min(640px, 100%);\n  box-sizing: border-box;\n  padding: 1.35rem 1.4rem 1.5rem;\n  max-height: min(90vh, 860px);\n  max-height: min(90dvh, 860px);\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.dialog-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 1rem;\n  margin-bottom: 1.1rem;\n\n  .eyebrow {\n    margin: 0;\n    font-size: 0.72rem;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: #5ea1d8;\n  }\n\n  h2 {\n    margin: 0.25rem 0 0.35rem;\n    font-size: 1.35rem;\n    color: #0f172a;\n  }\n\n  .subtitle {\n    margin: 0;\n    color: #64748b;\n    font-size: 0.9rem;\n    line-height: 1.45;\n    max-width: 480px;\n  }\n}\n\n.close-btn {\n  border: none;\n  background: #f1f5f9;\n  border-radius: 999px;\n  width: 36px;\n  height: 36px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: #475569;\n  flex-shrink: 0;\n}\n\n.balance-banner {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  padding: 0.75rem 1rem;\n  margin-bottom: 1rem;\n  border-radius: 10px;\n  background: rgba(94, 161, 216, 0.1);\n  border: 1px solid rgba(94, 161, 216, 0.22);\n\n  .label {\n    font-size: 0.75rem;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: #64748b;\n    font-weight: 600;\n  }\n\n  .value {\n    font-weight: 700;\n    color: #0f172a;\n  }\n\n  .detail {\n    font-weight: 500;\n    color: #64748b;\n    font-size: 0.85rem;\n  }\n}\n\n.pack-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 0.75rem;\n\n  @media (min-width: 640px) {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n.pack-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.25rem;\n  text-align: left;\n  padding: 1rem;\n  border-radius: 12px;\n  border: 2px solid #e2e8f0;\n  background: #fff;\n  cursor: pointer;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n\n  &.featured {\n    border-color: rgba(94, 161, 216, 0.45);\n  }\n\n  &.selected {\n    border-color: #5ea1d8;\n    box-shadow: 0 0 0 1px rgba(94, 161, 216, 0.25);\n  }\n\n  .badge {\n    position: absolute;\n    top: -0.55rem;\n    right: 0.65rem;\n    background: #5ea1d8;\n    color: #fff;\n    font-size: 0.65rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    padding: 0.15rem 0.45rem;\n    border-radius: 999px;\n  }\n\n  .pack-name {\n    font-weight: 700;\n    color: #0f172a;\n    margin-top: 0.25rem;\n  }\n\n  .pack-coins {\n    color: #64748b;\n    font-size: 0.9rem;\n  }\n\n  .pack-price {\n    margin-top: 0.35rem;\n    font-size: 1.25rem;\n    font-weight: 700;\n    color: #5ea1d8;\n  }\n\n  .pack-note {\n    font-size: 0.7rem;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: #94a3b8;\n    font-weight: 600;\n  }\n}\n\n.dialog-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  margin-top: 1.25rem;\n}\n\n.btn-cancel,\n.btn-purchase {\n  border-radius: 8px;\n  padding: 0.6rem 1.1rem;\n  font-weight: 600;\n  cursor: pointer;\n  border: 1px solid transparent;\n}\n\n.btn-cancel {\n  background: #fff;\n  border-color: #cbd5e1;\n  color: #0f172a;\n}\n\n.btn-purchase {\n  background: #5ea1d8;\n  color: #fff;\n}\n\n/* Mobile */\n@media (max-width: 640px) {\n  .ai-coin-dialog {\n    padding: 1rem 0.9rem calc(1rem + env(safe-area-inset-bottom, 0px));\n    max-height: calc(100vh - 16px);\n    max-height: calc(100dvh - 16px);\n    border-radius: 16px;\n  }\n\n  .dialog-header {\n    gap: 0.65rem;\n    margin-bottom: 0.9rem;\n\n    h2 {\n      font-size: 1.15rem;\n    }\n\n    .subtitle {\n      font-size: 0.82rem;\n      max-width: none;\n    }\n  }\n\n  .close-btn {\n    width: 32px;\n    height: 32px;\n  }\n\n  .balance-banner {\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 0.7rem 0.85rem;\n  }\n\n  .pack-grid {\n    grid-template-columns: 1fr;\n    gap: 0.65rem;\n  }\n\n  .pack-card {\n    padding: 0.9rem;\n  }\n\n  .dialog-actions {\n    flex-direction: column-reverse;\n    align-items: stretch;\n    gap: 0.55rem;\n    margin-top: 1rem;\n  }\n\n  .btn-cancel,\n  .btn-purchase {\n    width: 100%;\n    min-height: 44px;\n    justify-content: center;\n  }\n}\n\n/* Dark mode — AI coin top-up modal */\n:host-context(body.theme-dark) {\n  .ai-coin-dialog {\n    background: #111827 !important;\n    color: #e2e8f0 !important;\n  }\n\n  .dialog-header {\n    .eyebrow {\n      color: #93c5fd !important;\n    }\n\n    h2 {\n      color: #f8fafc !important;\n    }\n\n    .subtitle {\n      color: #94a3b8 !important;\n    }\n  }\n\n  .close-btn {\n    background: #1f2937 !important;\n    color: #e2e8f0 !important;\n\n    mat-icon,\n    .mat-icon {\n      color: #e2e8f0 !important;\n    }\n  }\n\n  .balance-banner {\n    background: rgba(94, 161, 216, 0.14) !important;\n    border-color: rgba(94, 161, 216, 0.28) !important;\n\n    .label,\n    .detail {\n      color: #94a3b8 !important;\n    }\n\n    .value {\n      color: #f8fafc !important;\n    }\n  }\n\n  .pack-card {\n    background: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n\n    &.featured {\n      border-color: rgba(94, 161, 216, 0.55) !important;\n    }\n\n    &.selected {\n      border-color: #5ea1d8 !important;\n      box-shadow: 0 0 0 1px rgba(94, 161, 216, 0.35) !important;\n    }\n\n    .pack-name {\n      color: #f8fafc !important;\n    }\n\n    .pack-coins,\n    .pack-note {\n      color: #94a3b8 !important;\n    }\n\n    .pack-price {\n      color: #93c5fd !important;\n    }\n  }\n\n  .btn-cancel {\n    background: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.45) !important;\n    color: #e2e8f0 !important;\n  }\n\n  .btn-purchase {\n    color: #ffffff !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
